module.exports = __webpack_public_path__ + "img/vip_mb_tab_01.09626529.png";